var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHype02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1209.4532 680.32001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,680.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.4609,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 164.926,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 247.387,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 329.852,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 412.313,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 494.773,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 577.238,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659.699,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 742.16,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 824.625,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907.086,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 989.551,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1072.01,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1154.47,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1236.94,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1319.4,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1401.86,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1484.32,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1566.79,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1649.25,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1731.71,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1814.17,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1896.64,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1979.1,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2061.56,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2144.02,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2226.49,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2308.95,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2391.41,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2473.87,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2556.34,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2638.8,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2721.26,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2803.72,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2886.18,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2968.65,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3051.11,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3133.57,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3216.03,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3298.5,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3380.96,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3463.42,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3545.88,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3628.35,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3710.81,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3793.27,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3875.73,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3958.2,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4040.66,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4123.12,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4205.58,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4288.05,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4370.51,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4452.97,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4535.43,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4617.9,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4700.36,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4782.82,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4865.28,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4947.75,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5030.21,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5112.67,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5195.13,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5277.59,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5360.06,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5442.52,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5524.98,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5607.44,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5689.91,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5772.37,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5854.83,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5937.29,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6019.76,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6102.22,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6184.68,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6267.14,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6349.61,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6432.07,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6514.53,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6596.99,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6679.46,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6761.92,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6844.38,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6926.84,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7009.31,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7091.77,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7174.23,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7256.69,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7339.16,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7421.62,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7504.08,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7586.54,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7669.01,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7751.47,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7833.93,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7916.39,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7998.86,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8081.32,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8163.78,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8246.24,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8328.7,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8411.17,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8493.63,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8576.09,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8658.55,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8741.02,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8823.48,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8905.94,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8988.4,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9070.87,5102.36 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.1406,5102.36 -42.1406,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 124.602,5102.36 40.3242,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 207.063,5102.36 122.785,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289.527,5102.36 205.246,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 371.988,5102.36 287.711,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 454.449,5102.36 370.172,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 536.914,5102.36 452.637,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619.375,5102.36 535.098,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 701.84,5102.36 617.563,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 784.301,5102.36 700.023,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 866.762,5102.36 782.484,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 949.227,5102.36 864.949,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031.69,5102.36 947.41,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1114.15,5102.36 1029.87,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1196.61,5102.36 1112.34,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1279.08,5102.36 1194.8,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1361.54,5102.36 1277.26,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1444,5102.36 1359.72,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1526.46,5102.36 1442.18,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1608.92,5102.36 1524.65,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1691.39,5102.36 1607.11,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1773.85,5102.36 1689.57,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1856.31,5102.36 1772.03,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1938.77,5102.36 1854.5,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2021.24,5102.36 1936.96,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2103.7,5102.36 2019.42,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2186.16,5102.36 2101.88,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2268.62,5102.36 2184.35,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2351.09,5102.36 2266.81,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2433.55,5102.36 2349.27,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2516.01,5102.36 2431.73,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2598.47,5102.36 2514.2,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2680.94,5102.36 2596.66,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2763.4,5102.36 2679.12,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2845.86,5102.36 2761.58,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2928.32,5102.36 2844.05,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3010.79,5102.36 2926.51,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3093.25,5102.36 3008.97,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3175.71,5102.36 3091.43,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3258.17,5102.36 3173.9,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3340.64,5102.36 3256.36,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3423.1,5102.36 3338.82,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3505.56,5102.36 3421.28,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3588.02,5102.36 3503.75,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3670.49,5102.36 3586.21,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3752.95,5102.36 3668.67,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3835.41,5102.36 3751.13,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3917.87,5102.36 3833.6,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4000.34,5102.36 3916.06,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4082.8,5102.36 3998.52,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4165.26,5102.36 4080.98,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4247.72,5102.36 4163.44,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4330.18,5102.36 4245.91,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4412.65,5102.36 4328.37,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4495.11,5102.36 4410.83,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4577.57,5102.36 4493.29,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4660.03,5102.36 4575.76,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4742.5,5102.36 4658.22,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4824.96,5102.36 4740.68,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4907.42,5102.36 4823.14,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4989.88,5102.36 4905.61,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5072.35,5102.36 4988.07,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5154.81,5102.36 5070.53,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5237.27,5102.36 5152.99,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5319.73,5102.36 5235.46,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5402.2,5102.36 5317.92,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5484.66,5102.36 5400.38,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5567.12,5102.36 5482.84,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5649.58,5102.36 5565.31,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5732.05,5102.36 5647.77,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5814.51,5102.36 5730.23,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5896.97,5102.36 5812.69,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5979.43,5102.36 5895.16,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6061.9,5102.36 5977.62,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6144.36,5102.36 6060.08,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6226.82,5102.36 6142.54,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6309.28,5102.36 6225.01,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6391.75,5102.36 6307.47,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6474.21,5102.36 6389.93,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6556.67,5102.36 6472.39,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6639.13,5102.36 6554.86,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6721.6,5102.36 6637.32,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6804.06,5102.36 6719.78,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6886.52,5102.36 6802.24,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6968.98,5102.36 6884.7,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7051.45,5102.36 6967.17,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7133.91,5102.36 7049.63,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7216.37,5102.36 7132.09,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7298.83,5102.36 7214.55,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7381.29,5102.36 7297.02,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7463.76,5102.36 7379.48,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7546.22,5102.36 7461.94,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7628.68,5102.36 7544.4,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7711.14,5102.36 7626.87,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7793.61,5102.36 7709.33,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7876.07,5102.36 7791.79,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7958.53,5102.36 7874.25,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8040.99,5102.36 7956.72,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8123.46,5102.36 8039.18,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8205.92,5102.36 8121.64,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8288.38,5102.36 8204.1,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8370.84,5102.36 8286.57,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8453.31,5102.36 8369.03,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8535.77,5102.36 8451.49,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8618.23,5102.36 8533.95,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8700.69,5102.36 8616.42,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8783.16,5102.36 8698.88,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8865.62,5102.36 8781.34,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8948.08,5102.36 8863.8,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9030.54,5102.36 8946.26,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9113.01,5102.36 9028.73,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHype02);
export default __webpack_public_path__ + "static/media/Hype_02.ba45a2c3d8a7a970d95650444d11c168.svg";
export { ForwardRef as ReactComponent };